/* eslint-disable import/no-unused-modules */
import { APP_SCOPE } from '@nx/constants';
import { createLogger } from '@nx/logger/legacy';

const rootLog = createLogger(APP_SCOPE.explore);

export { rootLog as log, rootLog as nvlLog, rootLog as ssoLog, rootLog as perfLog, rootLog as neo4jDriverLog };
